.bo{justify-content:flex-end;}